import React from "react";
import CardApp from "./components/CardApp";
import LogoPoliConScritta from "../../../images/logo_est_polito_EC_noBackgroud.png";
import GDPPoli from "../../../images/gdp_poli_no_Background.png";
import LogoGDP from "../../../images/logoGDP.png";
import ResIcon from "../../../images/resIcon.png";
import OilIcon from "../../../images/oilIcon.png";
import EtaitIcon from "../../../images/etaitIcon.png";
import MareIcon from "../../../images/mareIcon.png";
import OffshoreIcon from "../../../images/offshoreIcon.png";
import { connect } from "react-redux";
import { BiPowerOff } from "react-icons/bi";
import { logout } from "../../../actions/auth";
import {
  URL_OIL,
  URL_SEA,
  URL_RES,
  URL_OFFSHORE,
  URL_ADMIN,
} from "../../../actions/types";
import "./WrapperApps.css";
import { Row } from "reactstrap";
import { Col } from "reactstrap";

export const WrapperApps = (props) => {
  return (
    <div className="backgroundWrapperApps">
      <div style={{ display: "flex", width: "100%" }}>
        {localStorage.getItem("auth_token") !== "null" &&
        localStorage.getItem("auth_token") !== null &&
        localStorage.getItem("auth_token") !== undefined ? (
          <div
            style={{
              display: "flex",
              justifyContent: "start",
              flex: 1,
              paddingLeft: 20,
              paddingTop: 15,
            }}
          >
            <div
              style={{
                padding: "2px 10px 3px 10px",
                color: "#F7F7F7",
                border: "1px solid #F7F7F7",
                borderRadius: 5,
                cursor: "pointer",
                zIndex: 1,
              }}
              className="whiteOnHover"
            >
              <a
                href={`${URL_ADMIN}?auth=${localStorage.getItem("auth_token")}`}
                style={{ color: "white", textDecoration: "none" }}
                className="whiteOnHoverLink"
              >
                Admin Panel
              </a>
            </div>
          </div>
        ) : null}

        <div
          style={{
            display: "flex",
            justifyContent: "end",
            flex: 1,
            paddingRight: 20,
            paddingTop: 20,
          }}
        >
          <BiPowerOff
            className="logout"
            onClick={() => props.logout()}
          ></BiPowerOff>
        </div>
      </div>

      <ul className="circles">
        <li></li>
        <li></li>
        <li></li>
        <li></li>
      </ul>
      <img src={LogoPoliConScritta} className="imgLogo fadeInPoli"></img>
      {/* <img
        src={GDPPoli}
        className="imgLogo fadeInPoli"
        style={{ width: "40%", marginTop: "-70px", marginBottom: "-20px" }}
      ></img> */}
      <div
        className="fadeInPoli"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: "60px",
          color: "white",
          fontSize: "22px",
          fontWeight: "bold",
        }}
      >
        … PLAT.form of energy
      </div>
      <div className="rowApps">
        <Row
          style={{
            display: "flex",
            justifyContent: "center",
            margin: 0,
            padding: 0,
          }}
        >
          <Col
            xl="3"
            lg="4"
            md="6"
            sm="12"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <CardApp
              name_app="RES"
              name_token="res_token"
              name_frame="res_frame"
              url={URL_RES}
              icon={ResIcon}
              text={
                "Renewable energies and evaluation methods for plant installation and selection of recommended areas"
              }
              color="#3dc14d"
            ></CardApp>
          </Col>
          <Col
            xl="3"
            lg="4"
            md="6"
            sm="12"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <CardApp
              name_app="OIL"
              name_token="oil_token"
              name_frame="oil_frame"
              url={URL_OIL}
              icon={OilIcon}
              text={
                "Analysis of crude oil supplies, refined petroleum products and simulation of flow interruption and coverage"
              }
              color="#E0A33F"
            ></CardApp>
          </Col>
          <Col
            xl="3"
            lg="4"
            md="6"
            sm="12"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <CardApp
              name_app="WAVE"
              name_token="sea_token"
              name_frame="sea_frame"
              url={URL_SEA}
              icon={MareIcon}
              text={
                "Energy production from wave and analysis of resource assessment"
              }
              color="#5BB8F1"
            ></CardApp>
          </Col>
          <Col
            xl="3"
            lg="4"
            md="6"
            sm="12"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <CardApp
              name_app="OFFSHORE WIND"
              name_token="offshorewind_token"
              name_frame="offshorewind_frame"
              url={URL_OFFSHORE}
              icon={OffshoreIcon}
              text={
                "Energy production from offshore wind and analysis of resource assessment"
              }
              color="#477ADB"
            ></CardApp>
          </Col>
          <Col
            xl="3"
            lg="4"
            md="6"
            sm="12"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <CardApp
              name_app="ET@IT"
              name_token="etait_token"
              name_frame="etai_frame"
              url={""}
              icon={EtaitIcon}
              text={
                "Analysis of the Italian energy system in an energy transition perspective and tracking of its evolutive trajectory"
              }
              color="#E0A33F"
            ></CardApp>
          </Col>
        </Row>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { logout })(WrapperApps);
